/** Couleurs de la charte (THEME_COLOR_*) puis teintes complémentaires pour les graphiques à nombreuses parts */
export const PALETTE = ['#24396b', '#66cccc', '#e0c011', '#4a67ad', '#ef9400', '#3fbd63', '#9b6bd1', '#ea4e2c', '#828282', '#c2cbdc'];
export const OTHERS_COLOR = '#c2cbdc';
export const NEGATIVE_COLOR = '#ea4e2c';

export const colorAt = index => PALETTE[index % PALETTE.length];

/** Couleur hexadécimale avec transparence (0 à 1) */
export function withAlpha(hex, alpha) {
    const value = hex.replace('#', '');
    const [red, green, blue] = [0, 2, 4].map(offset => parseInt(value.slice(offset, offset + 2), 16));
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}
